


























































































// @ is an alias to /src
import { Vue, Component } from 'vue-property-decorator';
import registerComp from '@/components/RegisterComp.vue';
import PermUtil from '@/model/PermUtil';

@Component({
  components: {
    registerComp,
  },
})
export default class Register extends Vue {
  regis = true;

  searchKey = '';

  searchResult = [];

  mounted() {
    this.$store.dispatch('bindApprovedOrganizations');
  }

  doSearch(searchKey: any) {
    if (searchKey) {
      const filtered = this.Orgs
        .filter((org: any) => (org.name.toUpperCase().match(searchKey.toUpperCase())));
      this.searchResult = filtered;
    } else {
      this.searchResult = [];
    }
  }

  get Orgs() {
    return this.$store.state.approvedOrganizations;
  }
  // eslint-disable-next-line
  get showRegister() {
    return PermUtil.canCreateOrganization();
  }

  orgComp(org: any) {
    this.$store.dispatch('bindOrgObj', org.id);
    // this.$store.commit('setOrg', org);
    this.$router.push(`/organization/${org.id}`);
  }
}
